export default function(){							/*判斷機型*/
    var osUserAgent = navigator.userAgent.toLowerCase();
    if (osUserAgent.indexOf("iphone") > -1 || osUserAgent.indexOf("ipad") > -1 || osUserAgent.indexOf("ipod") > -1) {
        return "iphone";
    } else if (osUserAgent.indexOf("android") > -1 || osUserAgent.indexOf("adr") > -1) {
        return "android";
    } else if (osUserAgent.indexOf("awesomium") > -1) {
        return "u3d";
    } else if (osUserAgent.indexOf("untiypcsdk") > -1) {
        return "u3dPc";
    } else {
        return "windows";
    }
}